const MAX_LENGTH = 500;
// eslint-disable-next-line no-control-regex
const CONTROL_OR_BACKSLASH = new RegExp('[\u0000-\u001f' + String.fromCharCode(92, 92) + ']');

/**
 * Accepts only same-site relative paths ("/x"), so a return URL carried through
 * login/linking can never send the member to another origin.
 */
export function safeReturnTo(raw: string | null | undefined): string | null {
  if (!raw || raw.length > MAX_LENGTH) return null;
  if (!raw.startsWith('/')) return null;
  if (raw.startsWith('//')) return null;
  if (CONTROL_OR_BACKSLASH.test(raw)) return null;
  return raw;
}
